import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';

import { IntegratedIReckonHotel } from '@era/locations-sdk';

export type IntegratedIReckonHotelState = EntityState<IntegratedIReckonHotel>;

export function selectIReckonIntegratedHotelIdFromHotel(hotel: IntegratedIReckonHotel) {
  return hotel.locationUniqueId;
}

export const adapter: EntityAdapter<IntegratedIReckonHotel> = createEntityAdapter<IntegratedIReckonHotel>({
  selectId: selectIReckonIntegratedHotelIdFromHotel,
});

export const initialState: IntegratedIReckonHotelState = adapter.getInitialState();
